<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 1)"
  template="<img src='../assets/images/kizilay.png' />"
  type="ball-scale-multiple"
>
</ngx-spinner>
